import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';

function WithCharCount(WrappedComponent) {

	const CharCountWrapper = ({ maxCharCount = 1000, className = '', ...props }) => {

		const [ charCount, setCharCount ] = useState(0);
		const inputRef = useRef();

		useEffect( () => {
			if ( inputRef.current ) {
				inputRef.current.focus();
				setCharCount(props.value ? props.value.length : 0);
			}
		}, [] );
  
		return (
			<div className='modal-children__count-field'>
				<WrappedComponent
					{ ...props }
					ref={ inputRef }
					onChange = { (e) => {
						if (e.target.value.length <= maxCharCount) {
							setCharCount(e.target.value.length);
							if (props.onChange) {
								props.onChange(e);
							}
						}
					} }
				/>
				<div className = { className } > { `${charCount}/${maxCharCount}` } </div>
			</div>
		);
	};
  
	CharCountWrapper.propTypes = {
		maxCharCount: PropTypes.number,
		className: PropTypes.string,
	};
  
	return CharCountWrapper;
}

export default WithCharCount;
